
export interface ICompletedImageResultsLayoutEventArgs {
}

export class ImageResultListEvents {
  public static imageResultsLayoutComplete = 'imageResultsLayoutComplete';
}



/** WEBPACK FOOTER **
 ** ./src/events/ImageResultListEvents.ts
 **/